import React, { useState } from 'react';
import './ProfileOrLogin.css';
import Login from './Login';
import Signup from './Signup';
import './Login.css';
import './Signup.css';
import { useUser } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';

function ProfileOrLogin() {
  const { user, handleLogout, isSignupOpen, onSignupOpen, onSignupClose } = useUser();
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  return (
    <div className="profile-container">
      {/* Only show profile if there is a non-anonymous user */}
      {user && !user.isAnonymous ? (
        <>
          <div onClick={toggleModal} className="profile-link">
            {user.photoURL ? (
              <img
                src={user.photoURL}
                alt="Profile"
                className="profile-picture"
                referrerPolicy="no-referrer"
              />
            ) : (
              <span className="profile-text">Profile</span>
            )}
          </div>
          {/* Modal popup */}
          {isModalOpen && (
            <div className="modal-popup">
              <button
                className="modal-option"
                onClick={() => {
                  setModalOpen(false);
                  navigate("/settings");
                }}
              >
                Settings
              </button>
              <button className="modal-option" onClick={() => handleLogout(navigate)}>Log Out</button>
            </div>
          )}
        </>
      ) : (
        <>
          <a
            href="#login"
            className="open-login-modal-link"
            onClick={(e) => {
              e.preventDefault();
              setLoginOpen(true);
            }}
          >
            Login
          </a>
          <Login
            isOpen={isLoginOpen}
            onClose={() => setLoginOpen(false)}
            onSignupOpen={onSignupOpen}
          />
          <Signup
            isOpen={isSignupOpen}
            onClose={onSignupClose}
          />
        </>
      )}
    </div>
  );
}

export default ProfileOrLogin;
